'use client';

import { Figtree } from 'next/font/google';

export const figtree = Figtree({
  weight: ['400', '500', '600', '700'],
  style: ['normal', 'italic'],
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-inter',
});

export const FontPreset = () => (
  <style jsx global>{`
    html {
      --font-figtree: ${figtree.style.fontFamily};
    }
  `}</style>
);
